module.exports = __webpack_public_path__ + "static/media/api-icon.e290d075.svg";